export const _ = {
  // Deve restare allineata a android/app/build.gradle (versionName), a MARKETING_VERSION su iOS e a
  // ENV.MIN_SUPPORTED_FE_VERSION del backend: il blocco all'avvio confronta la versione NATIVA con
  // quella minima del backend, e questa è solo il fallback quando il nativo non risponde.
  VERSION: '1.342',
  MSxMINUTE: 60000,
  USER_GROUPS_VISIBILITY_CACHE_SECONDS: 5,
  // API_URL:'http://localhost:3000',
  // AUTH_URL: '/auth',
  EMAIL_KEY: '_YF_EMAIL',
  CLIENT_KEY: '_YF_CLIENT',
  AUTHSTATE_KEY: '_YF_AUTHSTATE',
  IMPERSONATOR_KEY: '_YF_IMPERSONATOR',
  GEOLOCATION_KEY: '_YF_GEOLOCATION',
  // Override manuale della posizione di partenza mappa (solo admin, 5-tap sulla lente): [lng, lat].
  MAP_START_OVERRIDE: '_YF_MAP_START_OVERRIDE',
  FAVOURITE_CAR_KEY: '_YF_FAVOURITE_CAR',
  VERSION_KEY: '_YF_VERSION',
  MIN_SUPPORTED_VERSION_KEY: '_YF_VERSION',
  SELECTED_FILTER: '_YF_SELECTED_FILTER',
  RECENT_SEARCHES: '_YF_RECENT_SEARCHES',
  CHAPTERS_KEY: '_YF_CHAPTERS',
  SESSION_HISTORY: '_YF_SESSION_HISTORY',
  LANG_KEY: '_YF_LANG',
  NOTIF_PREFS_PROMPTED_KEY: 'YF_NOTIF_PREFS_PROMPTED',
  OCPI_SESSION_TIMEOUT: 60,
  LAST_LOGIN_TYPE: '_YF_LAST_LOGIN_TYPE',
  MIGRATION_TAG_KEY: '_YF_MIGRATION_TAG',
  MIGRATION_TAG: 'v1.334-clean-1',
};
